import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

import { ORIGINAL_IMAGE_HOST } from '../../../constants/api';


export function hiPhotoSwipeInit() {
  const imageElements = document.getElementsByClassName('hi-listing-page__carousel-img') as HTMLCollectionOf<HTMLImageElement>;
  for (let element of imageElements) {
    element.addEventListener('click', ev => onCarouselImageClick(ev));
  }
}

function getPropertyImagesByType(type: 'LISTING' | 'BUILDING') {
  const elements = document.querySelectorAll<HTMLImageElement>(`img[data-image-set=${type}`);
  const images: string[] = [];

  elements.forEach(element => {
    images.push(element.src || element.dataset.src || element.dataset.slideSrc);
  });
  
  return images;
}

function getOriginalImageUrl(optimizedImage: string) {
  // We don't want to give out unwatermarked original images, but we do
  // need images in their full (watermarked) size.
  const [_s, origPath] = optimizedImage.match(/https?:\/\/[a-z0-9\.]+\/(.*)/);

  // Remove the _orig part, then remove the query string
  const watermarkedPath = origPath.replace(/_orig\./, '.').replace(/\?.*$/, '');
  const url = `https://${ORIGINAL_IMAGE_HOST}/${watermarkedPath}`;

  return url;
}

function loadImageData(src: string) {
  const promise = new Promise<HTMLImageElement>((resolve, reject) => {
    const origImg = document.createElement('img');
    origImg.src = src;
    origImg.classList.add('d-none');

    origImg.onload = () => resolve(origImg);
    origImg.onerror = () => reject();
    document.body.append(origImg);
  });

  return promise;
}

function onCarouselImageClick(event: MouseEvent) {
  const elem = event.target as HTMLImageElement;
  // Ensure that imageSet can only be either 'BUILDING' or 'LISTING'
  const imageSet = elem.dataset.imageSet == 'BUILDING' ? 'BUILDING' : 'LISTING';
  const images = getPropertyImagesByType(imageSet);
  const index = images.findIndex(src => src === elem.src);

  // console.log('Images:', images);
  // console.log('Clicked index', index);

  const url = getOriginalImageUrl(elem.src);

  // Show the loading spinner and overlay
  const carousels = document.getElementsByClassName('hi-listing-page__carousel');
  for (let carousel of carousels) {
    carousel.classList.add('popup-loading');
  }

  // If the page was reloaded while PhotoSwipe is visible, its fragment params
  // will remain in the URL. This will cause PhotoSwipe to try to go back to
  // the slide position where the user left off, instead of starting at the
  // slide corresponding the image that was clicked. This is extra weird if the
  // image set (listing or building image) is changed.
  // 
  // We *could* disable that, but that also breaks PhotoSwipe's hide-on-back
  // behavior. So we just clear the fragment before initializing PhotoSwipe.
  if (location.hash) {
    location.hash = '';
  }

  // Load the image so we can get its dimensions. When it's time for
  // PhotoSwipe to show the image, it'll be in the cache -- no duplicate
  // data over the wire.
  loadImageData(url).then(origImg => {
    let items = images.map(image => ({
      src: getOriginalImageUrl(image),
      // PhotoSwipe wants dimensions ahead of time.
      // This will be updated with the actual dimensions when the image is loaded
      w: 1,
      h: 1
    }));

    // We already know the dimensions for the original-size version of the image
    // that was clicked, so we can set those immediately.
    items[index].src = url;
    items[index].w = origImg.width;
    items[index].h = origImg.height;

    const options = {
      index,
      shareEl: false
    };

    for (let carousel of carousels) {
      carousel.classList.remove('popup-loading');
    }

    const pswpElement = document.querySelectorAll('.pswp')[0] as HTMLElement;
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    // PhotoSwipe is smart about image loading, proactively retrieving the
    // image data for adjacent slides, so next/prev actions feel super quick.
    gallery.listen('imageLoadComplete', (index, item) => {
      // When PhotoSwipe loads the image, get its data and update the slide
      // item with the image's actual dimensions.

      // console.log('Loaded image', index, item);
      loadImageData(item.src).then(elem => {
        item.w = elem.width;
        item.h = elem.height;
        gallery.updateSize(true);
      })
    });
    gallery.init();
  });
}
